
let language = {

    // 
    PC_RESOURCE_LIB_SET_SELECT_ALL_BTN: "Select all",
    PC_RESOURCE_LIB_SET_CANCEL_ALL_BTN: "Cancel all",
    PC_RESOURCE_LIB_SET_SELECTED_TITLE: "Selected:",
    PC_RESOURCE_LIB_SET_SAVE_BTN: "Save",
    
    PC_RESOURCE_LIB_SET_SEARCH_PLACEHOLDER: "Search",
    
    // 
    // PC_RESOURCE_LIB_SET_MY_RESOURCE_TITLE: "My",
    
};

export { language }